/* ============================================================
   NICK & JOE — CRÉE TON MIX · Builder de mélange (fiche contenant)
   ------------------------------------------------------------
   Lit les données injectées par melange-produit.liquid
   (<script type="application/json" data-nj-mix-data>).

   RÈGLES MÉTIER (notes 2026-07-15) :
   - Contenant à prix fixe, N portions (cases).
   - Chaque bonbon a un poids par portion PROPRE au contenant.
   - Stock IBE tenu en UNITÉS (pots/boîtes) × poids unitaire.
   - Buffer d'unités soustrait du stock disponible.
   - À chaque ajout : (qté+1) × poidsPortion ≤ stockDisponibleG
     sinon → blocage + plafonnement + alerte inventaire.
   ============================================================ */
(function () {
  /* Pictos +/- (repris de assets/icon-plus.svg & icon-minus.svg —
     inline_asset_content n'existe pas côté JS, on les embarque ici). */
  const SVG_PLUS = '<svg class="nj-icon-plus" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';
  const SVG_MINUS = '<svg class="nj-icon-minus" viewBox="0 0 10 2" fill="none" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg>';
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     ⚙️ CONFIG — VARIABLES À MODIFIER POUR BRANCHER LES VRAIS STOCKS
     ═══════════════════════════════════════════════════════════ */
  const CONFIG = {
    /* Source du stock :
       'liquid'   → stock embarqué au chargement de la page
                    (variant.inventory_quantity = stock TOUTES localisations,
                    approximation OK pour dev/test)
       'endpoint' → fetch temps réel vers un app proxy qui retourne le
                    stock de la localisation IBE seulement (À DISCUTER) */
    STOCK_SOURCE: 'liquid',

    /* App proxy à créer côté Shopify (Admin API inventory_levels
       filtré sur LOCATION_IBE_ID). Doit retourner :
       { "<variantId>": <unités en stock à IBE>, ... } */
    STOCK_ENDPOINT: '/apps/nick-joe/stock-ibe?variant_ids={ids}', // 🔌 À BRANCHER
    LOCATION_IBE_ID: null, // 🔌 À REMPLIR (ID localisation Iberville)

    /* Re-vérifier le stock endpoint à chaque ajout (true) ou
       seulement au chargement (false). true = fidèle aux notes,
       mais + de requêtes. */
    REVALIDATE_ON_ADD: true,

    /* Extras (bonbons premium) : les line item properties ne changent
       PAS le prix. Pour facturer les extras, on ajoute AU PANIER une
       ligne « Supplément mélange » PAR PALIER de prix : chaque palier
       (0,99 $, 1,99 $…) est une variante distincte du produit Supplément,
       et quantity = nombre de portions à ce palier. La map prix→variante
       est injectée par Liquid (DATA.extraVariants). Ces lignes restent
       SÉPARÉES (pas de fusion : le garde-fou les niche visuellement sous
       le contenant au panier). */

    /* Format monnaie */
    MONEY: (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' $',

    /* Panier : line item properties. Préfixe "_" = caché au client
       sur la plupart des thèmes ; sans "_" = visible panier/checkout. */
    PROP_PREFIX_VISIBLE: 'Bonbon',   // ex. "Bonbon 1: Fraises sûres × 5"
    PROP_MIX_JSON: '_mix_json',      // détail machine-readable minimal pour le décrément (Flow) + garde-fou
    // ⚠️ RENOMMÉ `_mix_id` → `_mix_grp` (23/07) : une ANCIENNE fonction Cart
    // Transform orpheline (fonction `019f8488…`, sans inscription mais encore
    // invoquée par intermittence au checkout — cache Shopify tenace) regroupe et
    // FUSIONNE les lignes qui portent l'attribut `_mix_id`, ce qui scramble le
    // prix au checkout. En n'utilisant plus JAMAIS `_mix_id`, l'orpheline ne
    // trouve rien à regrouper → défaite garantie côté thème.
    PROP_MIX_ID: '_mix_grp',         // id liant contenant ↔ Supplément (garde-fou)
    PROP_MIX_REF: '_mix_ref',        // même id, posé sur les lignes BONBON
                                     // sinon la Cart Transform met le bonbon dans le groupe fusionné
                                     // et Shopify multiplie le bundle par la quantité de sacs au checkout.
    PROP_MIX_BONBON: '_mix_bonbon',  // marque une ligne composant bonbon (0 $, visible pour la validation stock)
  };

  /* ═══════════════ Données injectées par Liquid ═══════════════ */
  const dataEl = document.querySelector('[data-nj-mix-data]');
  if (!dataEl) return;
  const DATA = JSON.parse(dataEl.textContent);
  const CONTENANT = DATA.contenant;
  /* Map { prixEnCents(string) → variantId } des variantes du produit « Supplément
     mélange », injectée par Liquid (une variante par palier d'extra). Sert à
     facturer chaque palier par sa propre variante au prix exact. */
  const EXTRA_VARIANTS = (DATA.extraVariants && typeof DATA.extraVariants === 'object') ? DATA.extraVariants : {};
  /* Variante Supplément correspondant à un montant d'extra (en cents), ou null
     si aucun palier de ce prix n'existe sur le produit Supplément. */
  const extraVariantForCents = (cents) => EXTRA_VARIANTS[String(cents)] || null;
  const I18N = DATA.i18n || {};
  /* Image par défaut (asset thème) injectée par Liquid : affichée telle quelle
     — pas de transform `?width=` : les assets thème ne sont pas redimensionnables. */
  const DEFAULT_IMG = DATA.defaultImage || '';
  /* Bonbons chargés en différé depuis l'asset mix-bonbons.json (produits taggés `mix`,
     300+ possibles → hors du cap des 50 produits/collection de Liquid). Rempli à l'init ;
     on garde la MÊME référence de tableau pour que toutes les closures restent valides. */
  const BONBONS = [];

  /* ═══════════════ État ═══════════════ */
  let mix = {}; // bonbonId -> qté de portions
  let filtre = 'all';     // tag actif ('all' = tous)
  let recherche = '';     // texte de recherche (titre), minuscule
  let tri = 'defaut';     // 'defaut' = ordre de l'asset (curation) | 'az'
  let wasFull = false;    // suivi de l'état « plein » pour déclencher l'explosion à la transition

  /* ═══════════════ Helpers ═══════════════ */
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];
  const bonbon = (id) => BONBONS.find((b) => b.id === Number(id));
  const totalPortions = () => Object.values(mix).reduce((s, q) => s + q, 0);

  /* Stock disponible en grammes pour un bonbon :
     sacs fermés : unités × poids unitaire, plancher 0
     + grammes restants du sac ENTAMÉ (metafield sac_ouvert_g,
       modèle « sac ouvert » — décision 15/07).
     02/11/2026 : marge de sécurité (custom.buffer_unites) retirée — le client vend tout son stock. */
  const stockDisponibleG = (b) =>
    Math.max(0, b.stockUnitesLive * b.poidsUnitaireG) + (b.sacOuvertG || 0);

  /* Nb max de portions possibles pour un bonbon selon le stock */
  const maxPortionsStock = (b) =>
    b.poidsPortionG > 0 ? Math.floor(stockDisponibleG(b) / b.poidsPortionG) : 0;

  /* Prix total = prix fixe contenant + extras éventuels */
  const prixTotalCents = () =>
    CONTENANT.priceCents +
    Object.entries(mix).reduce((s, [id, q]) => s + (bonbon(id).extraParPortionCents || 0) * q, 0);

  /* ═══════════════ Stock temps réel (app proxy) ═══════════════ */
  async function refreshStockLive() {
    if (CONFIG.STOCK_SOURCE !== 'endpoint') return;
    try {
      const ids = BONBONS.map((b) => b.variantId).join(',');
      const res = await fetch(CONFIG.STOCK_ENDPOINT.replace('{ids}', ids));
      if (!res.ok) throw new Error('stock endpoint ' + res.status);
      const stocks = await res.json(); // { variantId: unités, ... }
      BONBONS.forEach((b) => {
        if (stocks[b.variantId] != null) b.stockUnitesLive = Number(stocks[b.variantId]);
      });
    } catch (err) {
      /* Fallback silencieux sur le stock Liquid — à logger côté monitoring si besoin */
      console.warn('[NJ-MIX] Stock IBE indisponible, fallback stock Liquid.', err);
    }
  }

  /* ═══════════════ Ajout / retrait avec validation ═══════════════ */
  async function add(id) {
    const b = bonbon(id);
    if (!b) return;

    /* 1. Capacité du contenant */
    if (totalPortions() >= CONTENANT.nbPortions) {
      toast(`Contenant plein — ${CONTENANT.nbPortions} portions de 100 g max 🍬`);
      return;
    }

    /* 2. Re-vérification du stock IBE avant CHAQUE ajout (notes 15/07) */
    if (CONFIG.REVALIDATE_ON_ADD) await refreshStockLive();

    /* 3. Validation : encore 1 portion possible ? */
    const qteVoulu = (mix[b.id] || 0) + 1;
    const maxStock = maxPortionsStock(b);
    if (qteVoulu > maxStock) {
      /* Plafonnement + alerte inventaire (cas "3 × 500 g → 2 et alerte") */
      if (maxStock > 0) mix[b.id] = Math.min(mix[b.id] || 0, maxStock);
      alerteInventaire(b, maxStock);
      render();
      return;
    }

    mix[b.id] = qteVoulu;
    hideAlerte();
    render();
  }

  function remove(id) {
    if (!mix[id]) return;
    mix[id]--;
    if (mix[id] <= 0) delete mix[id];
    hideAlerte();
    render();
  }

  /* ═══════════════ Alerte inventaire ═══════════════ */
  function alerteInventaire(b, maxStock) {
    const el = $('[data-nj-mix-alert]');
    if (el) {
      el.hidden = false;
      el.innerHTML =
        maxStock > 0
          ? `⚠️ Stock limité pour <b>${b.title}</b> — maximum ${maxStock} portion${maxStock > 1 ? 's' : ''} disponible${maxStock > 1 ? 's' : ''}.`
          : `⚠️ <b>${b.title}</b> n'est plus disponible en quantité suffisante.`;
    }
    toast(`Stock insuffisant : ${b.title}`);
    /* 🔌 À BRANCHER (optionnel) : notifier l'équipe (webhook, Klaviyo,
       tag Shopify…) qu'un client a atteint la limite de stock IBE. */
    console.info('[NJ-MIX] ALERTE INVENTAIRE', {
      bonbon: b.title,
      variantId: b.variantId,
      stockUnites: b.stockUnitesLive,
      dispoG: stockDisponibleG(b),
      maxPortions: maxStock,
    });
  }
  function hideAlerte() {
    const el = $('[data-nj-mix-alert]');
    if (el) el.hidden = true;
  }

  /* ═══════════════ Explosion de bonbons (jauge pleine) ═══════════════
     Salve de particules jaillissant du haut de la jauge quand elle atteint
     100 %. Web Animations API, aucune dépendance. Les sprites sont des formes
     SVG pour l'instant — remplaçables par des PNG fournis par la DA : il suffit
     de changer le corps de makeParticle() (voir la ligne commentée). */
  const BURST_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  const BURST_COLORS = ['#00a4ff', '#ff5a8a', '#ff5a5f', '#8bc34a', '#ff9f1c', '#9b5de5', '#ffd23f'];
  const BURST_SPRITES = [
    '<circle cx="50" cy="50" r="46"/>',
    '<rect x="10" y="30" width="80" height="40" rx="20"/>',
    '<path d="M50 10l11 25 27 2-21 18 7 26-24-14-24 14 7-26-21-18 27-2z"/>',
    '<path d="M30 24a11 11 0 1 1 9 17 19 19 0 0 1 22 0 11 11 0 1 1 9-17 23 23 0 0 1-6 62 25 25 0 0 1-28 0 23 23 0 0 1-6-62z"/>',
  ];

  function makeParticle(color, size) {
    const el = document.createElement('span');
    const sprite = BURST_SPRITES[(Math.random() * BURST_SPRITES.length) | 0];
    el.innerHTML = `<svg viewBox="0 0 100 100" width="${size}" height="${size}" fill="${color}" style="display:block">${sprite}</svg>`;
    // 🔁 Swap PNG (DA) : remplacer la ligne ci-dessus par
    //    el.innerHTML = `<img src="${pngUrl}" width="${size}" height="${size}" alt="">`;
    return el;
  }

  function burstBonbons() {
    if (BURST_REDUCED.matches) return;
    const gauge = $('.nj-mix-bag__gauge');
    if (!gauge) return;
    const r = gauge.getBoundingClientRect();
    const originX = r.left + r.width / 2;
    const originY = r.top + 6; // juste sous le bord haut de la jauge
    const layer = document.createElement('div');
    Object.assign(layer.style, {
      position: 'fixed', inset: '0', pointerEvents: 'none', zIndex: '9999', overflow: 'hidden',
    });
    document.body.appendChild(layer);

    const N = 26;
    let alive = N;
    const done = () => { if (--alive <= 0) layer.remove(); };
    for (let i = 0; i < N; i++) {
      const color = BURST_COLORS[(Math.random() * BURST_COLORS.length) | 0];
      const size = 14 + Math.random() * 16;
      const p = makeParticle(color, size);
      Object.assign(p.style, {
        position: 'absolute', left: originX + 'px', top: originY + 'px',
        willChange: 'transform, opacity',
      });
      layer.appendChild(p);

      const angle = (-90 + (Math.random() * 120 - 60)) * Math.PI / 180; // hémisphère haut
      const dist = 60 + Math.random() * 130;
      const dx = Math.cos(angle) * dist;
      const peak = 80 + Math.random() * 90;   // hauteur du saut
      const fall = 260 + Math.random() * 170; // retombée (gravité)
      const rot = Math.random() * 720 - 360;
      const dur = 900 + Math.random() * 550;

      const anim = p.animate(
        [
          { transform: 'translate(-50%,-50%) translate(0px,0px) rotate(0deg) scale(.4)', opacity: 1, offset: 0, easing: 'cubic-bezier(.15,.6,.35,1)' },
          { transform: `translate(-50%,-50%) translate(${dx * 0.5}px,${-peak}px) rotate(${rot * 0.5}deg) scale(1)`, opacity: 1, offset: 0.35, easing: 'cubic-bezier(.5,0,.75,.45)' },
          { transform: `translate(-50%,-50%) translate(${dx}px,${fall}px) rotate(${rot}deg) scale(.9)`, opacity: 0, offset: 1 },
        ],
        { duration: dur, fill: 'forwards' }
      );
      anim.onfinish = done;
      anim.oncancel = done;
    }
    setTimeout(() => layer.remove(), 2000); // filet de sécurité
  }

  /* ═══════════════ Tuiles (rendu client depuis l'asset) ═══════════════ */
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const imgUrl = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  function tileHTML(b) {
    const media = b.image
      ? `<img class="nj-mix-bonbon__media-image" src="${imgUrl(b.image, 300)}" srcset="${imgUrl(b.image, 150)} 150w, ${imgUrl(b.image, 200)} 200w, ${imgUrl(b.image, 300)} 300w" sizes="(min-width: 750px) 200px, 33vw" alt="${esc(b.title)}" width="300" height="300" loading="lazy">`
      : DEFAULT_IMG
      ? `<img class="nj-mix-bonbon__media-image nj-mix-bonbon__media-image--default" src="${esc(DEFAULT_IMG)}" alt="${esc(b.title)}" width="300" height="300" loading="lazy">`
      : '<span class="nj-mix-bonbon__media-image nj-mix-bonbon__media-image--placeholder" aria-hidden="true"></span>';
    const tags = (b.tags || []).map((t) => String(t).toLowerCase());
    const badge = tags.includes('nouveaute')
      ? `<span class="nj-mix-bonbon__badge nj-mix-bonbon__badge--nouveaute">${esc(I18N.badgeNew || 'Nouveauté')}</span>`
      : tags.includes('tendance')
      ? `<span class="nj-mix-bonbon__badge nj-mix-bonbon__badge--tendance">${esc(I18N.badgeTrending || 'Tendance')}</span>`
      : '';
    const extraSlot = b.extraParPortionCents > 0
      ? '<p class="nj-mix-bonbon__content--extra" data-nj-mix-extra hidden></p>' : '';
    return `<article class="nj-mix-bonbon__wrapper" data-nj-mix-tile="${b.id}">
      <div class="nj-mix-bonbon__media">${media}${badge}</div>
      <div class="nj-mix-bonbon__content">
        <div class="nj-mix-bonbon__content--name">${esc(b.title)}</div>
        ${extraSlot}
        <div class="nj-mix-bonbon__content--buy" data-nj-mix-buy></div>
      </div>
    </article>`;
  }
  function buildTiles() {
    const grid = $('[data-nj-mix-grid]');
    if (!grid) return;
    grid.innerHTML = BONBONS.length
      ? BONBONS.map(tileHTML).join('')
      : '<p class="nj-mix-empty">Aucun bonbon disponible pour le moment.</p>';
  }
  /* Compteurs par tag + révélation des puces non vides (rendues cachées par Liquid). */
  function buildFilters() {
    const counts = {};
    BONBONS.forEach((b) => (b.tags || []).forEach((t) => {
      const k = String(t).toLowerCase(); counts[k] = (counts[k] || 0) + 1;
    }));
    $$('[data-nj-mix-filter-count]').forEach((span) => {
      const key = span.getAttribute('data-nj-mix-filter-count');
      if (key === 'all') { span.textContent = `(${BONBONS.length})`; return; }
      const n = counts[key] || 0;
      span.textContent = `(${n})`;
      const chip = span.closest('[data-nj-mix-filter]');
      if (chip) chip.hidden = n === 0;
    });
  }

  /* ═══════════════ Rendu ═══════════════ */
  function render() {
    const n = totalPortions();
    const cap = CONTENANT.nbPortions;
    const plein = n >= cap;

    /* Tuiles bonbons */
    BONBONS.forEach((b) => {
      const buyEl = $(`[data-nj-mix-tile="${b.id}"] [data-nj-mix-buy]`);
      if (!buyEl) return;
      const qte = mix[b.id] || 0;
      const maxStock = maxPortionsStock(b);
      const epuise = maxStock <= 0;
      const majore = !epuise && qte >= maxStock; /* stock atteint pour CE bonbon */
      const plus_off = plein || epuise || majore;

      buyEl.innerHTML = qte > 0
        ? `<div class="nj-mix-qty">
             <button type="button" class="nj-mix-qty__minus" data-nj-mix-minus="${b.id}" aria-label="Retirer une portion de ${esc(b.title)} (actuellement ${qte})">${SVG_MINUS}</button>
             <span class="nj-mix-qty__n">${qte}</span>
             <button type="button" class="nj-mix-qty__plus" data-nj-mix-plus="${b.id}" aria-label="Ajouter une portion de ${esc(b.title)} (actuellement ${qte})" ${plus_off ? 'disabled' : ''}>${SVG_PLUS}</button>
           </div>`
        : `<button type="button" class="nj-mix-add" data-nj-mix-plus="${b.id}" ${plein || epuise ? 'disabled' : ''}>
             ${epuise ? 'Épuisé' : plein ? 'Plein' : `${SVG_PLUS}<span>Ajouter</span>`}
           </button>`;
      buyEl.closest('.nj-mix-bonbon__wrapper').classList.toggle('is-in', qte > 0);
      buyEl.closest('.nj-mix-bonbon__wrapper').classList.toggle('is-out', epuise);
    });

    /* Panneau mélange */
    const pct = Math.round((n / cap) * 100);
    const fill = $('[data-nj-mix-fill]');
    if (fill) {
      fill.style.height = pct + '%';
      fill.setAttribute('aria-valuemax', cap);
      fill.setAttribute('aria-valuenow', n);
      fill.setAttribute('aria-valuetext', `${n} portion${n > 1 ? 's' : ''} sur ${cap}`);
    }
    // À l'instant où la jauge atteint le plein (rejoue à chaque passage) :
    // explosion de bonbons + ouverture auto du bottom-sheet mobile.
    if (plein && !wasFull && cap > 0) {
      setTimeout(burstBonbons, 260);
      window.dispatchEvent(new CustomEvent('nj-mix-full'));
    }
    wasFull = plein;
    // Deux compteurs superposés (noir sous la photo, blanc dessus) → on met les deux à jour.
    $$('[data-nj-mix-pct]').forEach((e) => (e.textContent = `${n}/${cap}`));
    setText('[data-nj-mix-cap]', `${n} / ${cap} portions`);
    const rem = cap - n;
    setHTML(
      '[data-nj-mix-nudge]',
      n === 0 ? `Choisis tes ${cap} portions de 100 g`
      : n < cap ? `Encore <b>${rem}</b> portion${rem > 1 ? 's' : ''}`
      : 'Contenant plein ✓ — c’est complet!'
    );

    const listEl = $('[data-nj-mix-list]');
    if (listEl) {
      const ids = Object.keys(mix);
      listEl.innerHTML = ids.length
        ? ids.map((id) => {
            const b = bonbon(id);
            const majore = mix[id] >= maxPortionsStock(b);
            const extraTxt = b.extraParPortionCents ? ` (+${CONFIG.MONEY(b.extraParPortionCents * mix[id])})` : '';
            return `<li>
              <div class="nj-mix-line__name"><b>${b.title}</b><span>×${mix[id]}${extraTxt}</span></div>
              <div class="nj-mix-qty">
                <button type="button" class="nj-mix-qty__minus" data-nj-mix-minus="${id}" aria-label="Retirer une portion de ${esc(b.title)} (actuellement ${mix[id]})">${SVG_MINUS}</button>
                <span class="nj-mix-qty__n">${mix[id]}</span>
                <button type="button" class="nj-mix-qty__plus" data-nj-mix-plus="${id}" aria-label="Ajouter une portion de ${esc(b.title)} (actuellement ${mix[id]})" ${plein || majore ? 'disabled' : ''}>${SVG_PLUS}</button>
              </div>
            </li>`;
          }).join('')
        : '<li class="nj-mix-empty">Aucun bonbon choisi.</li>';
    }

    setText('[data-nj-mix-price]', CONFIG.MONEY(prixTotalCents()));
    const checkout = $('[data-nj-mix-checkout]');
    /* Décision 15/07 : le contenant DOIT être plein pour commander. */
    if (checkout) checkout.disabled = n !== cap;
  }

  // Met à jour TOUS les éléments correspondants (un même hook peut être dupliqué,
  // ex. le prix / le compteur repris dans la barre sticky mobile).
  const setText = (sel, v) => { $$(sel).forEach((e) => { e.textContent = v; }); };
  const setHTML = (sel, v) => { $$(sel).forEach((e) => { e.innerHTML = v; }); };

  /* ═══════════════ Badges « premium » sur les tuiles ═══════════════
     Statique (le supplément ne change pas) → rendu une fois à l'init.
     Format monnaie identique au panier / recap (CONFIG.MONEY). */
  function renderTileExtras() {
    BONBONS.forEach((b) => {
      if (!(b.extraParPortionCents > 0)) return;
      const el = $(`[data-nj-mix-tile="${b.id}"] [data-nj-mix-extra]`);
      if (!el) return;
      el.textContent = `+${CONFIG.MONEY(b.extraParPortionCents)}/portion`;
      el.hidden = false;
    });
  }

  /* ═══════════════ Filtres (tags produits) + tri ═══════════════
     Les tuiles sont rendues par Liquid ; on masque/réordonne le DOM.
     Tri « defaut » = ordre des entrées metaobject (curation client). */
  function applyFiltreTri() {
    const grid = $('[data-nj-mix-grid]');
    if (!grid) return;
    let liste = [...BONBONS];
    if (tri === 'az') liste.sort((a, b) => a.title.localeCompare(b.title, 'fr'));
    liste.forEach((b) => {
      const tile = $(`[data-nj-mix-tile="${b.id}"]`);
      if (!tile) return;
      const matchFiltre =
        filtre === 'all' ||
        (b.tags || []).some((t) => t.toLowerCase() === filtre.toLowerCase());
      const matchRech = !recherche || String(b.title).toLowerCase().includes(recherche);
      tile.style.display = (matchFiltre && matchRech) ? '' : 'none';
      grid.appendChild(tile); /* ré-ordonne selon le tri */
    });
  }

  function toast(msg) {
    const t = $('[data-nj-mix-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    t.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => { t.classList.remove('show'); t.hidden = true; }, 2200);
  }

  /* ═══════════════ Panier — couche isolée ═══════════════
     1 ligne panier = le contenant (prix fixe) + line item properties.
     ⚠️ Les stocks des bonbons ne sont PAS décrémentés par Shopify
     avec cette approche (À DISCUTER — cf. README). Le détail du mix
     part dans _mix_json pour la préparation / un futur décrément
     via app ou Flow. */
  /* Récupère le sac_ouvert_g LIVE des variantes choisies via la Storefront API.
     Le snapshot (shop metafield) est régénéré au cron et peut être périmé ; le Flow
     s'appuie sur cette valeur pour l'accounting « sac ouvert ». Fallback silencieux
     sur le snapshot si le token n'est pas configuré ou si la requête échoue. */
  async function fetchLiveSacOuvert(variantIds) {
    const token = DATA.storefrontToken;
    if (!token || !variantIds.length) return {};
    const ver = DATA.storefrontApiVersion || '2026-07';
    const ids = variantIds.map((id) => `gid://shopify/ProductVariant/${id}`);
    try {
      const res = await fetch(`/api/${ver}/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
        body: JSON.stringify({
          query: 'query($ids:[ID!]!){ nodes(ids:$ids){ ... on ProductVariant { id so: metafield(namespace:"custom", key:"sac_ouvert_g"){ value } } } }',
          variables: { ids },
        }),
      });
      if (!res.ok) throw new Error('storefront ' + res.status);
      const j = await res.json();
      const out = {};
      for (const n of (j.data && j.data.nodes) || []) {
        if (!n || !n.id) continue;
        out[Number(String(n.id).split('/').pop())] = Number(n.so && n.so.value) || 0;
      }
      return out;
    } catch (err) {
      console.warn('[NJ-MIX] sac_ouvert live indisponible → fallback snapshot.', err);
      return {};
    }
  }

  async function addMixToCart() {
    // Identifiant unique du mélange : posé à l'identique sur la ligne contenant
    // ET sa ligne Supplément (et, via _mix_ref, sur les lignes bonbon) → le
    // garde-fou panier apparie ces lignes pour les grouper/nicher visuellement.
    // ⚠️ NE PAS réutiliser la clé `_mix_id` (cf. PROP_MIX_ID) : une ancienne
    // fonction Cart Transform orpheline fusionnait les lignes `_mix_id` et
    // scramblait le prix au checkout (résolu en désinstallant l'app).
    const mixId =
      (self.crypto && crypto.randomUUID && crypto.randomUUID()) ||
      Date.now().toString(36) + Math.random().toString(36).slice(2);
    const properties = { [CONFIG.PROP_MIX_ID]: mixId };
    let i = 0;
    /* Extras agrégés PAR PALIER de prix (cents → nb de portions) : chaque palier
       devient une ligne « Supplément » distincte, facturée par sa propre variante. */
    const extrasParPalier = Object.create(null);
    // ⚠️ Plus de LIGNE panier par bonbon → checkout propre (Contenant + Supplément
    // seulement, plan Advanced sans fusion). Le décrément d'inventaire se fait via
    // le Flow « Order created » qui lit _mix_json (sacs + inventoryItemId) et appelle
    // inventoryAdjustQuantities. Le détail des bonbons reste dans _mix_json + les
    // propriétés visibles « Bonbon N » du contenant.
    const mixDetail = [];
    // sac_ouvert_g LIVE des bonbons choisis (le snapshot du shop metafield peut être
    // périmé entre deux crons → sinon le Flow rouvre des sacs à tort, cf. NJ-178).
    const liveSac = await fetchLiveSacOuvert(Object.keys(mix).map((id) => bonbon(id).variantId));
    for (const [id, q] of Object.entries(mix)) {
      const b = bonbon(id);
      i += 1;
      const grammes = q * b.poidsPortionG;
      const extraUnit = b.extraParPortionCents || 0;
      if (extraUnit > 0) extrasParPalier[extraUnit] = (extrasParPalier[extraUnit] || 0) + q;
      // Sacs neufs = ce qui n'est pas couvert par le sac entamé (valeur LIVE si dispo), arrondi au sac.
      const sacOuvert = (liveSac[b.variantId] != null) ? liveSac[b.variantId] : (b.sacOuvertG || 0);
      const poidsSac = b.poidsUnitaireG || 1;
      const sacs = grammes <= sacOuvert ? 0 : Math.ceil((grammes - sacOuvert) / poidsSac);
      const extraTxt = extraUnit ? ` (+${CONFIG.MONEY(extraUnit * q)})` : '';
      properties[`${CONFIG.PROP_PREFIX_VISIBLE} ${i}`] = `${b.title} × ${q}${extraTxt}`;
      mixDetail.push({ variantId: b.variantId, inventoryItemId: b.inventoryItemId, poidsG: grammes, sacs, sacOuvert, poidsSac, qty: q, extraUnitCents: extraUnit, extraCents: extraUnit * q });
    }
    properties[CONFIG.PROP_MIX_JSON] = JSON.stringify(mixDetail);

    const items = [{ id: CONTENANT.variantId, quantity: 1, properties }];

    /* Extras : une ligne « Supplément mélange » PAR PALIER de prix (variante au
       prix exact, quantité = nb de portions à ce palier). Appariées au contenant
       par _mix_grp → le garde-fou panier les niche et les réconcilie par palier. */
    for (const [cents, portions] of Object.entries(extrasParPalier)) {
      const variantId = extraVariantForCents(cents);
      if (variantId) {
        items.push({
          id: variantId,
          quantity: portions,
          properties: { 'Pour': CONTENANT.title, [CONFIG.PROP_MIX_ID]: mixId },
        });
      } else {
        /* Ne devrait pas arriver (le garde-fou d'init force à 0 tout extra sans
           variante) : filet de sécurité → on ne facture pas un palier introuvable. */
        console.warn('[NJ-MIX] Palier extra ' + CONFIG.MONEY(Number(cents)) + ' sans variante Supplément → non facturé.');
      }
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Erreur ajout panier');
    }
    return res.json();
  }

  /* ═══════════════ Événements ═══════════════ */
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-nj-mix-filter]');
    if (chip) {
      filtre = chip.dataset.njMixFilter;
      $$('[data-nj-mix-filter]').forEach((c) => c.classList.toggle('is-on', c === chip));
      applyFiltreTri();
      return;
    }
    const plus = e.target.closest('[data-nj-mix-plus]');
    const minus = e.target.closest('[data-nj-mix-minus]');
    if (plus && !plus.disabled) { add(plus.dataset.njMixPlus); return; }
    if (minus) { remove(minus.dataset.njMixMinus); return; }
    // Vider en 2 clics : le 1er arme le bouton (« Confirmer ? » pendant 3 s), le 2e vide le mélange.
    // (Pas de boîte de dialogue native : bloquante, non stylable, non traduite — règle nj-lint R1.)
    const clearBtn = e.target.closest('[data-nj-mix-clear]');
    if (clearBtn) {
      const desarmer = () => {
        clearTimeout(clearBtn._njMixTimer);
        delete clearBtn.dataset.njMixArmed;
        if (clearBtn.dataset.njMixLabel) clearBtn.textContent = clearBtn.dataset.njMixLabel;
        clearBtn.classList.remove('is-armed');
      };
      if (clearBtn.dataset.njMixArmed !== '1') {
        clearBtn.dataset.njMixArmed = '1';
        clearBtn.dataset.njMixLabel = clearBtn.textContent;
        clearBtn.textContent = I18N.bagClearConfirm || clearBtn.textContent;
        clearBtn.classList.add('is-armed');
        clearBtn._njMixTimer = setTimeout(desarmer, 3000);
        return;
      }
      desarmer();
      mix = {}; hideAlerte(); render(); return;
    }
    if (e.target.closest('[data-nj-mix-checkout]')) {
      const btn = e.target.closest('[data-nj-mix-checkout]');
      btn.disabled = true;
      addMixToCart()
        .then(() => {
          mix = {};
          document.dispatchEvent(new CustomEvent('nj-mix:added-to-cart'));
          /* Redirige vers le panier : l'utilisateur voit son mélange et ne
             peut pas ré-ajouter le même par accident (double-ajout). On
             conserve preview_theme_id le cas échéant (tests sur thème dev). */
          const pv = new URLSearchParams(location.search).get('preview_theme_id');
          window.location.assign('/cart' + (pv ? '?preview_theme_id=' + pv : ''));
        })
        .catch((err) => { toast(err.message); btn.disabled = false; });
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-nj-mix-sort]')) { tri = e.target.value; applyFiltreTri(); }
  });

  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-nj-mix-search]')) { recherche = e.target.value.trim().toLowerCase(); applyFiltreTri(); }
  });

  /* ═══════════════ Init ═══════════════ */
  function init() {
    /* Bonbons inlinés par Liquid depuis le(s) shop metafield(s) custom.mix_bonbons[_N].
       La liste est écrite en tranches (batch, limite 128 Ko/metafield) → tableau de
       tranches concaténé par le snippet. `.flat()` aplatit, et reste un no-op sur une
       ancienne liste à plat (rétro-compat). */
    const list = (Array.isArray(DATA.bonbons) ? DATA.bonbons : []).flat();
    list
      .map((b) => {
        /* Garde-fou invariant : un extra ne peut être facturé que s'il existe une
           variante Supplément à ce prix exact. Sinon on force l'extra à 0 PARTOUT
           (tuile, prix total, panier) → l'affiché reste toujours égal au facturé ;
           le warn dit au dev de créer la variante manquante. */
        let extra = b.extraParPortionCents || 0;
        if (extra > 0 && !extraVariantForCents(extra)) {
          console.warn('[NJ-MIX] Bonbon « ' + b.title + ' » : extra ' + CONFIG.MONEY(extra) + ' sans variante Supplément à ce prix → extra ignoré (créer la variante correspondante).');
          extra = 0;
        }
        return {
          ...b,
          extraParPortionCents: extra,
          stockUnitesLive: b.stockUnites,
        };
      })
      /* Décision 08/10 : les bonbons épuisés ne sont plus affichés grisés mais
         retirés de la liste (allège la grille). Le marquage « Épuisé » / is-out
         reste un filet pour un stock qui tomberait à 0 pendant la session. */
      .filter((b) => maxPortionsStock(b) > 0)
      .forEach((b) => BONBONS.push(b));
    buildTiles();
    buildFilters();
    refreshStockLive().then(() => { renderTileExtras(); render(); applyFiltreTri(); });
  }
  init();
})();
